<template>
  <mdb-container v-if="group">
    <banner-small :group="group" title="Suggestions"/>
    <div v-if="!showSuggestion && !editSuggestion"  class="text-left">
      <mdb-btn icon="lightbulb-on" @click="newSuggestion">Suggest an Event</mdb-btn>
      <mdb-card v-if="suggestions.length == 0">
        <mdb-card-header color="secondary">
          <h5>No Suggestions</h5>
        </mdb-card-header>
        <mdb-card-body>
          There are currently no current suggested events to view. Got an idea? Submit a suggestion yourself!
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-4 text-left" v-if="suggestions.length>0">
        <mdb-card-header>
          Suggestions
        </mdb-card-header>
        <mdb-card-body>
          <div class="mdb-feed">
            <div class="news" v-bind:key="suggestion.id" v-for="suggestion in suggestions">
              <div class="label">
                <gp-avatar :avatar="suggestion.createdByAvatar" :memberId="suggestion.createdById" container-class=""/>
              </div>
              <div class="excerpt">
                <div class="brief">
                  <div>
                    <a href="#" @click.prevent="showSuggestion = suggestion">{{suggestion.title}}</a>
                  </div>
                  <div class="text-info small">Suggested by {{suggestion.createdByName}}
                    <a v-if="suggestion.mayEdit" href="#" @click.prevent="editSuggestion = suggestion"><mdb-icon icon="pencil"/></a>
                  </div>
                </div>
              </div>
              <div style="clear:both;"/>
            </div>
          </div>
        </mdb-card-body>
      </mdb-card>


    </div>
    <suggestion-editor v-if="editSuggestion"
                       @cancel="editSuggestion=null"
                       @save="saveSuggestion"
                       :suggestion="editSuggestion"
                       />
    <suggestion-viewer v-if="showSuggestion"
                       @cancel="cancelShow"
                       @reload="viewReload"
                       :suggestion="showSuggestion"
    />
  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon} from 'mdbvue';
import BannerSmall from "../group/BannerSmall";
import SuggestionEditor from "./SuggestionEditor";
import SuggestionViewer from "./SuggestionViewer";
import gpAvatar from "../common/Avatar";

export default {
  name: 'Event-Suggestion',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbIcon,
    mdbBtn,
    BannerSmall,
    SuggestionEditor,
    SuggestionViewer,
    gpAvatar
  },
  data() {
    return {
      suggestions: [],
      showSuggestion: null,
      editSuggestion: null
    }
  },
  computed: {
    group: function () {
      return this.$store.state.currentGroup
    },
    userDetails: function() {
      return this.$store.state.userDetails
    }
  },
  async mounted() {
    if (!this.group || this.group.vanityPath != this.$route.params.id) {
      await api.groupBasics(this.$route.params.id, "member");
    }
    document.title = "Suggestions"
    this.loadSuggestions()
    api.trackGroupVisit(this.$route.params.id)
  },
  methods: {
    newSuggestion: function() {
      this.editSuggestion = {
        id: null,
        title: null,
        willingToHost: true,
        venueId: null,
        newVenueDescription: null,
        startDate: null
      }
    },
    cancelShow() {
      this.showSuggestion = null
      if (this.$route.query.suggestion) {
        this.$router.replace("/event/suggest/" + this.group.vanityPath )
      }
    },
    viewReload() {
      this.showSuggestion = null
      this.loadSuggestions()
    },
    loadSuggestions: function () {
      if (!this.group) {
        this.$router.push("/403")
        return
      }
      this.$store.dispatch("setExecuting", true);
      api.get("/event/suggestionList/" + this.group.vanityPath).then(
        (results) => {
          this.suggestions = results.data;
          if (this.$route.query.suggestion) {
            for (let i=0; i<this.suggestions.length; i++) {
              if (this.suggestions[i].id == this.$route.query.suggestion) this.showSuggestion = this.suggestions[i]
            }
          }
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
            return
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveSuggestion: function () {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/suggestion/" + this.group.vanityPath, this.editSuggestion).then(
        (results) => {
          if (!this.editSuggestion.id) this.suggestions.unshift(results.data)
          this.editSuggestion = null
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
            return
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>
